import { calender_shift } from 'utils/customWebengage'

const CalenderHeader = ({
    monthDate,
    decreaseMonth,
    increaseMonth,
    profile,
    minDate,
    maxDate,
}) => {
    const currentYear = monthDate.getFullYear()

    const isPrevDisabled =
        minDate &&
        monthDate.getFullYear() === minDate.getFullYear() &&
        monthDate.getMonth() === minDate.getMonth()

    const isNextDisabled =
        maxDate &&
        monthDate.getFullYear() === maxDate.getFullYear() &&
        monthDate.getMonth() === maxDate.getMonth()

    return (
        <div className="custom-header">
            <div className="current-month">
                {monthDate.toLocaleString('en-US', { month: 'long' })} {currentYear}
            </div>

            <div className="prev-next-container">
                {/* PREVIOUS */}
                <button
                    aria-label="Previous Month"
                    className={`chevron ${isPrevDisabled ? 'disabled' : ''}`}
                    onClick={!isPrevDisabled ? decreaseMonth : undefined}
                    disabled={isPrevDisabled}
                >
                    <svg width="20" height="20" viewBox="0 0 20 20">
                        <path
                            d="M7.08301 10.667L11.833 15.3337C12.1663 15.667 12.6663 15.667 12.9997 15.3337C13.333 15.0003 13.333 14.5003 12.9997 14.167L8.91634 10.0003L12.9997 5.83366C13.333 5.50033 13.333 5.00033 12.9997 4.66699C12.6663 4.33366 12.1663 4.33366 11.833 4.66699L7.08301 9.33366C6.74967 9.75033 6.74967 10.2503 7.08301 10.667Z"
                            fill={isPrevDisabled ? '#DDE2E5' : '#B5BEC6'}
                        />
                    </svg>
                </button>
                <button
                    aria-label="Next Month"
                    className={`chevron ${isNextDisabled ? 'disabled' : ''}`}
                    onClick={
                        !isNextDisabled
                            ? () => {
                                  increaseMonth()
                                  profile['month_changed'] = monthDate
                                  calender_shift(
                                      '5_Calendar_month_flip',
                                      profile,
                                      profile.exam_type
                                  )
                              }
                            : undefined
                    }
                    disabled={isNextDisabled}
                >
                    <svg width="20" height="20" viewBox="0 0 20 20">
                        <path
                            d="M12.9499 9.40796L8.23328 4.69962C7.9 4.36629 7.4 4.36629 7.06661 4.69962C6.73328 5.03296 6.73328 5.53296 7.06661 5.86629L11.1749 10.0413L7.06661 14.1663C6.73328 14.4996 6.73328 14.9996 7.06661 15.333C7.4 15.6663 7.9 15.6663 8.23328 15.333L12.9499 10.633C13.2833 10.2996 13.2833 9.79963 12.9499 9.40796Z"
                            fill={isNextDisabled ? '#DDE2E5' : '#B5BEC6'}
                        />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default CalenderHeader
